import {
  List,
  Datagrid,
  TextField,
  DateField,
  ShowButton,
  EditButton,
  ListActions,
  NumberInput,
  SimpleList,
} from "react-admin";
import { useMediaQuery } from "@mui/material";
import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import { checkPermission } from "server/security/utils";
import SecuredComponent from "server/security/SecuredComponent";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";

const ListHealthcareCampaign = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  const filters = [
    <NumberInput
      label="Година"
      source="coursesYear"
      alwaysOn
    />,
  ];

  return (
    <List
      title="Кампания за здравни грижи"
      exporter={false}
      filters={filters}
      actions={<ListActions hasCreate={checkPermission(getPermissions(), permissions.canManageHealthcareCampaigns)} />}
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Година", value: record?.coursesYear }]} />
          )}
          secondaryText={record => (
            <MobileListRow
              fields={[
                {
                  label: "Начало на кандидатстване",
                  value: (
                    <DateField
                      source="applicationStartTimestamp"
                      showTime
                      locales="bg-BG"
                    />
                  ),
                },
                {
                  label: "Край на кандидатстване",
                  value: (
                    <DateField
                      source="applicationEndTimestamp"
                      showTime
                      locales="bg-BG"
                    />
                  ),
                },
              ]}
            />
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canManageHealthcareCampaigns}>
                <EditButton label="" />
              </SecuredComponent>
              <SecuredComponent permission={permissions.canPreviewHealthcareCampaigns}>
                <ShowButton label="" />
              </SecuredComponent>
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="coursesYear"
            label="Година"
            sortable={false}
          />
          <DateField
            source="applicationStartTimestamp"
            label="Начало на кандидатстване"
            sortable={false}
            showTime
            locales="bg-BG"
          />
          <DateField
            source="applicationEndTimestamp"
            label="Край на кандидатстване"
            sortable={false}
            showTime
            locales="bg-BG"
          />
          <SecuredComponent permission={permissions.canManageHealthcareCampaigns}>
            <EditButton />
          </SecuredComponent>
          <SecuredComponent permission={permissions.canPreviewHealthcareCampaigns}>
            <ShowButton />
          </SecuredComponent>
        </Datagrid>
      )}
    </List>
  );
};

export default ListHealthcareCampaign;
